export default __webpack_public_path__ + "static/media/Group 101.18c50ecf.svg";